import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslocoDirective } from '@jsverse/transloco';
import { CustomerContact } from '../../../../interfaces/customer-contacts.model';

type ContactDialogData = {
  mode?: 'add' | 'edit';
  contact?: CustomerContact;
};

@Component({
  selector: 'cus-customers-add-contact-dialog-component',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule,
    TranslocoDirective,
  ],
  templateUrl: './customers-add-contact-dialog-component.html',
  styleUrl: './customers-add-contact-dialog-component.scss',
})
export class CustomersAddContactDialogComponent {
  private readonly data = inject<ContactDialogData | null>(MAT_DIALOG_DATA, { optional: true });
  addContactForm: FormGroup;
  readonly dialogMode = this.data?.mode ?? 'add';
  readonly dialogTitleKey = this.dialogMode === 'edit' ? 'contacts.form.editTitle' : 'contacts.form.addTitle';

  constructor(
    private dialogRef: MatDialogRef<CustomersAddContactDialogComponent>,
    private formBuilder: FormBuilder,
  ) {
    this.addContactForm = this.formBuilder.group({
      nomeCognome: [this.data?.contact?.nominativo ?? '', Validators.required],
      telefono: [this.data?.contact?.telefono ?? ''],
      cellulare: [this.data?.contact?.cellulare ?? ''],
      fax: [this.data?.contact?.fax ?? ''],
      email: [this.data?.contact?.email ?? ''],
      ruolo: [this.data?.contact?.ruolo ?? ''],
      note: [this.data?.contact?.note ?? ''],
      default: [{ value: this.data?.contact?.principale ?? false, disabled: true }],
    });
  }

  onClose() {
    this.dialogRef.close();
  }

  onReset() {
    this.addContactForm.reset({
      nomeCognome: '',
      telefono: '',
      cellulare: '',
      fax: '',
      email: '',
      ruolo: '',
      note: '',
      default: this.data?.contact?.principale ?? false,
    });
  }

  onApply() {
    if (this.addContactForm.invalid) {
      this.addContactForm.markAllAsTouched();
      return;
    }

    this.dialogRef.close(this.addContactForm.getRawValue());
  }
}
